import React from "react";
import { CloudPremisePluginMenu } from "@cloudpremise/portal_core";

// @mui icons
import Icon from "@mui/material/Icon";

const menus = (): CloudPremisePluginMenu[] => {
    return [
        {
            type: "menu_item",
            name: "My Queues",
            key: "availablequeues",
            icon: <Icon fontSize="medium">assignment_outlined</Icon>,
            route: "/bpm/queues/availablequeues",
            privacy: "private",
        },
    ];
};

export default menus;